"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlotDimensions = void 0;
const i_plot_area_1 = require("./i-plot-area");
/**
 * @public
 * {@inheritDoc IPlotDimensions}
 */
class PlotDimensions {
    constructor(clipSpaceArea, cssArea, pixelArea) {
        this.clipSpaceArea = clipSpaceArea;
        this.cssArea = cssArea;
        this.pixelArea = pixelArea;
    }
    /**
     * Origin bottom left (OBL).
     */
    static createOneOBL(clipSpaceRange, canvasDims) {
        return new PlotDimensions(clipSpaceRange, new i_plot_area_1.PlotArea(clipSpaceRange.wholeRange.mat3Multiply(canvasDims.transforms.clipToCss), clipSpaceRange.interactiveRange.mat3Multiply(canvasDims.transforms.clipToCss)), new i_plot_area_1.PlotArea(clipSpaceRange.wholeRange.mat3Multiply(canvasDims.transforms.clipToPixel), clipSpaceRange.interactiveRange.mat3Multiply(canvasDims.transforms.clipToPixel)));
    }
    /**
     * Origin top left (OTL).
     */
    static createOneOTL(clipSpaceRange, canvasDims) {
        const dims = new PlotDimensions(clipSpaceRange, new i_plot_area_1.PlotArea(clipSpaceRange.wholeRange.mat3Multiply(canvasDims.reverseYTransforms.clipToCss), clipSpaceRange.interactiveRange.mat3Multiply(canvasDims.reverseYTransforms.clipToCss)), new i_plot_area_1.PlotArea(clipSpaceRange.wholeRange.mat3Multiply(canvasDims.reverseYTransforms.clipToPixel), clipSpaceRange.interactiveRange.mat3Multiply(canvasDims.reverseYTransforms.clipToPixel)));
        // the y range is upside down,correct it
        dims.cssArea.interactiveRange.ensureAABB();
        dims.cssArea.wholeRange.ensureAABB();
        dims.pixelArea.interactiveRange.ensureAABB();
        dims.pixelArea.wholeRange.ensureAABB();
        return dims;
    }
    static createDefault() {
        return new PlotDimensions(i_plot_area_1.PlotArea.createDefault(), i_plot_area_1.PlotArea.createDefault(), i_plot_area_1.PlotArea.createDefault());
    }
}
exports.PlotDimensions = PlotDimensions;
//# sourceMappingURL=plot-dimensions.js.map